/** @format */

import { styled } from "@mui/material/styles";
import Page from "../../components/Page";
import {
  Container,
  Stack,
  Typography,
  Card,
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  CircularProgress,
  Grid,
} from "@mui/material";
import User from "../../dao/User";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import thirdPartyLogin from "../../configs/third-party-login";
import { Form, FormikProvider, useFormik } from "formik";
import React, { useState } from "react";
import Iconify from "../../components/Iconify";
import * as yup from "yup";
import { useSelector } from "react-redux";

import logo from "../../static/logo-infomedia.png"; // relative path to image
import illustration1 from "../../assets/illustration1.png";
import Swal from "../../reusables/CustomSwal";
import { wabaSetStatus } from "../../store/actions";
import Logout from "../../utils/logout";
import { resetAuth, resetWABA } from "../../store/actions";

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
}));

export default function ConfirmEmail() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  let auth = useSelector(({ auth }) => auth?.auth);
  const [isLoading, setIsLoading] = useState(false);

  const whatsappLogin = async (key) => {
    let req;
    if (auth.email === "admin@telin.com") {
      req =
        await thirdPartyLogin(`https://webhook.infomedia.co.id/subscribe_channel/waba-tech/?key=${key}
    `);
    } else {
      req =
        await thirdPartyLogin(`https://webhook.infomedia.co.id/subscribe_channel/waba/?key=${key}
      `);
    }
    if (req) {
      dispatch(wabaSetStatus({ status: "" }));
    }
  };

  const handleConnectFB = async () => {
    await setIsLoading(true);
    try {
      let response = await User.connectWFB({
        tenant: auth?.tenant,
        channel: "whatsapp",
        callback_url:
          "https://be-whatsapp-business.infomedia.co.id/v1/waba/callback/confirm",
        stream_url:
          "https://be-whatsapp-business.infomedia.co.id/v1/waba/callback/confirm",
        redirect_url: "https://digihub.infomedia.co.id/wapanel/",
      });
      // window.open(
      //   `https://webhook.infomedia.co.id/subscribe_channel/waba/?key=${response.data.key}`,
      //   "_self"
      // );
      whatsappLogin(response.data.key);
    } catch (e) {
      let errorMessage = "An error occurred.";
      if (e.code === "EMAIL_NOT_FOUND" || e.code === "USER_PASSWORD_WRONG") {
        errorMessage = "Invalid credentials";
      }
      await Swal.fire({
        title: "Error",
        text: errorMessage ? errorMessage : "An error Occured",
        icon: "error",
      });
      await setIsLoading(false);
    }

    await setIsLoading(false);
    // await navigate("/dashboard");
  };

  const RegisterSchema = yup.object().shape({
    facebookBusinessManager: yup
      .bool()
      .oneOf([true], "Need to agree this statemeent"),
    phoneNumberForWhatsApp: yup
      .bool()
      .oneOf([true], "Need to agree this statemeent"),
  });

  const formik = useFormik({
    initialValues: {
      facebookBusinessManager: false,
      phoneNumberForWhatsApp: false,
    },
    validationSchema: RegisterSchema,
    onSubmit: (values) => handleConnectFB(values),
  });

  const {
    values,
    errors,
    touched,
    dirty,
    setFieldValue,
    handleSubmit,
    isValid,
  } = formik;

  const checkBoxDatas = [
    {
      title: "Facebook Business Manager",
      data: [
        "Make sure you have access to your company`s Facebook Business Manager.",
      ],
      name: "facebookBusinessManager",
      label: "I have a Facebook account and understand the above",
    },
    {
      title: "Phone Number For WhatsApp Business",
      data: [
        "The number is not already being used on any WhatsApp or WhatsApp Business apps.",
        "You are able to receive a phone call or SMS to the phone number for the verification process.",
      ],
      name: "phoneNumberForWhatsApp",
      label: "I have a number with above requirements",
    },
  ];

  return (
    <RootStyle title="Connect with facebook">
      <Container maxWidth="sm">
        <ContentStyle>
          <Card sx={{ p: 4, height: "100%" }}>
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Stack>
                  <img
                    src={logo}
                    style={{ width: "150px", position: "absolute" }}
                    alt="logo-infomedia"
                  />
                  <Box
                    sx={{ width: "150px", position: "absolute", right: "0px" }}
                  >
                    <Button
                      sx={{ marginTop: "10px" }}
                      variant="contained"
                      onClick={() => {
                        Logout(navigate, dispatch(resetAuth()));
                        dispatch(resetWABA());
                      }}
                    >
                      {!isLoading ? (
                        <Typography>Logout</Typography>
                      ) : (
                        <>
                          <CircularProgress
                            size="22px"
                            sx={{ marginRight: 1 }}
                          />
                          Loading
                        </>
                      )}
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "70vw",
                    }}
                  >
                    <Typography variant="h3">You're almost there!</Typography>
                  </Box>
                  <Grid container>
                    <Grid item xs={6} lg={6}>
                      <img
                        src={illustration1}
                        style={{ width: "550px" }}
                        alt="illustration1"
                      />
                    </Grid>
                    <Grid item xs={6} lg={6}>
                      <Box>
                        {checkBoxDatas.map((item, index) => (
                          <Box key={index} sx={{ marginBottom: "10px" }}>
                            <Typography variant="h5">{item?.title}</Typography>
                            <ul>
                              {item.data.map((item2, index2) => (
                                <li key={index2}>{item2}</li>
                              ))}
                            </ul>
                            <FormControlLabel
                              value={item.data}
                              control={
                                <Checkbox
                                  checked={values[item.name]}
                                  onClick={() =>
                                    setFieldValue(
                                      `${item.name}`,
                                      !values[item.name]
                                    )
                                  }
                                />
                              }
                              label={item.label}
                              labelPlacement="end"
                            />
                            {errors[item.name] && touched[item.name] ? (
                              <p style={{ fontSize: 14, color: "red" }}>
                                {errors[item.name]}
                              </p>
                            ) : null}
                          </Box>
                        ))}
                        <Typography variant="h5">
                          Let’s begin the registration process. Complete all the
                          steps in the popup to create your WhatsApp Business
                          channel.
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  <Button
                    size="large"
                    type="submit"
                    sx={{ marginTop: "10px" }}
                    variant="contained"
                    disabled={!(isValid && dirty && !isLoading)}
                    loading={isLoading}
                  >
                    {!isLoading ? (
                      <>
                        <Iconify
                          icon="eva:save-outline"
                          width={22}
                          height={22}
                          sx={{ marginRight: 1 }}
                        />
                        Connect with Facebook Account
                      </>
                    ) : (
                      <>
                        <CircularProgress size="22px" sx={{ marginRight: 1 }} />
                        Loading
                      </>
                    )}
                  </Button>
                </Stack>
              </Form>
            </FormikProvider>
          </Card>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
